﻿/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 260428
*/
'use strict';

import {
    allSettled,
    getPromise,
    showMySNApiError
} from './ctssJQuery.js';
import {
    setModified
} from './ctssVal.js';
import {
    getGroupsQueryParam
} from './snGroups.js'
import {
    appDebugMode,
    ImgsFolder,
    getAppToken,
    getImgsBaseURLAsync
} from './snSite.js';

const token = getAppToken();

let groupImgsBaseURL = '';
let groups = [];
let hasGroups = false;
//let toolBarMenuItems = [];
let testFolderImgsBaseURL = '';

const getGroupsToolBarDataAsync = async (params) => {

    const { featureID } = params;
    if (!featureID) {
        alert('Feature ID is required to call getGroupsToolBarAsync')
    }
    const isAdmin = token.IsAdmin === "True";
    return await getPromise({
        url: `Groups/${token.CG}/${token.sub}/${isAdmin}/${featureID}/ToolBarData`
    })
}


const getToolBarMenuItemsAsync = async (params) => {

    const [gImgsBaseURL, toolBarData, tImgsBaseURL] =
        await allSettled({
            promises: [
                getImgsBaseURLAsync(ImgsFolder.Groups),
                getToolBarDataAsync(params),
                getImgsBaseURLAsync(ImgsFolder.TestFolder),
            ]
        });

    let dataRetrieved = false;

    if (gImgsBaseURL.status !== 'rejected' &&
        toolBarData.status !== 'rejected' &&
        tImgsBaseURL.status !== 'rejected') {

        groupImgsBaseURL = gImgsBaseURL.value;
        hasGroups = toolBarData.value.hasGroups;
        toolBarMenuItems = toolBarData.value.groups;
        testFolderImgsBaseURL = tImgsBaseURL.value;

        dataRetrieved = true;
    }

    return dataRetrieved;
}

const getGroupsToolBarMenuItem = (params = {}) => {
    const { value } = params;
    return groups[groups.findIndex(x => x.value === value)];
} 

const initGroupCtrlsAsync = async (params = {}) => {

    const [gImgsBaseURL, toolBarData, tImgsBaseURL] =
        await allSettled({
            promises: [
                getImgsBaseURLAsync(ImgsFolder.Groups),
                getGroupsToolBarDataAsync(params),
                getImgsBaseURLAsync(ImgsFolder.TestFolder),
            ]
        });

    if (gImgsBaseURL.status !== 'rejected' &&
        toolBarData.status !== 'rejected' &&
        tImgsBaseURL.status !== 'rejected') {

        const {
            useDDL,
            useToolBar
        } = params;

        groupImgsBaseURL = gImgsBaseURL.value;
        hasGroups = toolBarData.value.hasGroups;
        groups = toolBarData.value.groups;
        testFolderImgsBaseURL = tImgsBaseURL.value;

        const groupsQueryParam = token.IsAdmin === "True"
            ? getGroupsQueryParam()
            : getGroupsQueryParam({
                groups: groups,
                queryOperator: params.queryOperator
            });

        if (useToolBar === true) {
            initGroupsToolBar({
                showFilter: params.showFilter !== undefined && params.showFilter === true,
                groups,
                hasGroups,
                fnToolBarGroupDDLClick: params.fnToolBarGroupDDLClick
            })
        }
        if (useDDL === true) {
            initGroupsDDL({
                groupID: params.groupID,
                groups,
                fnGroupDDLClick: params.fnGroupDDLClick
            });
        }
        return {
            groupImgsBaseURL,
            groupsQueryParam,
            groups,
            hasGroups,
            testFolderImgsBaseURL
        }
    }

}

const initGroupsDDL = (params = {}) => {

    const groups = params.groups.filter(x => x.value !== '-1');
    if (groups.length === 0) {
        return;
    }

    const {
        groupID = '-1'
    } = params


    const g = groupID !== '-1'
        ? groups[groups.findIndex(x => x.value === groupID)]
        : groups[0];

    $('#hiddenGroupID').val(g.value);

    if (groups.length === 1) {
        $('#grpImg').prop('src', g.imgSrc);
        $('#grpDesc').html(g.text);
        $('#divGroupDisplay').removeClass('hidden');
    } else {

        const content = groups.reduce((acc, g) => {
            if (g.isFeatureEnabled) {
                return acc + `<li data-group_id="${g.value}" class="dropdown-item">` +
                    `<img src="${g.imgSrc}" data-group_id="${g.value}">${g.text}</li>`;
            }
        }, '');
        $('#divGroupDDL .dropdown-menu').html(content);

        $('#divGroupDDL .dropdown-item').off('click').click(e => {
            const {
                calledByGroupDlg,
                fnGroupDDLClick
            } = params;

            const g = groups[groups.findIndex(x => x.value === e.target.dataset.group_id)];

            if (calledByGroupDlg === true) {
                $('#hiddenNewgroupID').val(g.value); /* After clicking btnSelectGroup in Dlg - $('#hiddenGroupID') is set to this value; */
            } else {
                $('#hiddenGroupID').val(g.value);
            }
            $('#btnImgsDDL').html(`<img src="${g.imgSrc}"> ${g.text} <span class="caret"></span></span>`);
            setModified(true);
            if (fnGroupDDLClick) { fnGroupDDLClick(); }
        });
        $('#btnImgsDDL').html(`<img src="${g.imgSrc}"> ${g.text} <span class="caret"></span>`)
        $('#divGroupDDL').removeClass('hidden');
    }
}

const initGroupsToolBar = (params = {}) => {

    const {
        fnToolBarGroupDDLClick,
        groups,
        hasGroups,
        showFilter
    } = params;

    if (showFilter === true) {
        $('#groupsToolBar').removeClass('showToolBar').addClass('showFilter');
    } else {
        $('#groupsToolBar').removeClass('showFilter').addClass('showToolBar');
    }

    if (hasGroups) {

        $('#hiddenToolBarGroupID').val('-1');
        $('#btnToolBarImgsDDL').html(`<img src="${groups[0].imgSrc}"> ${groups[0].text} <span class="caret"></span></span>`)

        const content = groups.reduce((acc, g) => {
            return acc + `<li data-group_id="${g.value}" class="dropdown-item">` +
                `<img src="${g.imgSrc}" data-group_id="${g.value}">${g.text}</li>`;
        }, '');
        $('#divToolBarGroupDDL .dropdown-menu').html(content);

        $('#divToolBarGroupDDL .dropdown-menu')
            .html(content)
            .off('click').click(e => {
                const group_id = e.target.dataset.group_id || e.target.closest('li').dataset.group_id;
                const g = groups[groups.findIndex(x => x.value === group_id)];
                $('#hiddenToolBarGroupID').val(g.value);
                $('#hiddenGroupID').val(g.value);
                $('#btnToolBarImgsDDL').html(`<img src="${g.imgSrc}"> ${g.text} <span class="caret"></span></span>`);
                if (fnToolBarGroupDDLClick) { fnToolBarGroupDDLClick(); }
            });
        $('#groupsToolBar').removeClass('hidden');
    }
}

const setGroupsDDLContent = (params = {}) => {
    const {
        ddlListItems,
        groupID = '-1',
        groupImgsBaseURL,
        testFolderImgsBaseURL
    } = params;

    if (!ddlListItems || ddlListItems.length === 0) {
        return;
    }

    const g = groupID !== '-1'
        ? ddlListItems[ddlListItems.findIndex(x => x.value === groupID)]
        : ddlListItems[0];

    $('#hiddenGroupID').val(g.value);

    if (ddlListItems.length === 1) {
        $('#grpImg').off('error').on('error', (e) => {
            e.target.src = `${testFolderImgsBaseURL}${g.imgName}`;
        });
        $('#grpImg').prop('src', groupImgsBaseURL + g.imgName);
        $('#grpDesc').html(g.text);
        $('#divGroupDisplay').removeClass('hidden');
    } else {

        const content = ddlListItems.reduce((acc, g) => {
            if (g.isFeatureEnabled) {
                return acc + `<li data-group_id="${g.value}" class="dropdown-item">` +
                    `<img class="ddlImg" src="${groupImgsBaseURL}${g.imgName}" data-group_id="${g.value}" data-img_name="${g.imgName}">${g.text}</li>`;
            }
        }, '');
        $('#divGroupDDL .dropdown-menu').html(content);

        $('#divGroupDDL .dropdown-menu .ddlImg').off('error').on('error', (e) => {
            e.target.src = `${testFolderImgsBaseURL}${e.target.dataset.img_name}`;
        })

        $('#divGroupDDL .dropdown-item').off('click').click(e => {
            const {
                calledByGroupDlg,
                fnGroupDDLClick
            } = params;

            const g = ddlListItems[ddlListItems.findIndex(x => x.value === e.target.dataset.group_id)];

            if (calledByGroupDlg === true) {
                $('#hiddenNewgroupID').val(g.value); /* After clicking btnSelectGroup in Dlg - $('#hiddenGroupID') is set to this value; */
            } else {
                $('#hiddenGroupID').val(g.value);
            }
            $('#btnImgsDDL').html(`<img src="${groupImgsBaseURL}${g.imgName}" data-img_name="${g.imgName}"> ${g.text} <span class="caret"></span></span>`);
            setModified(true);
            if (fnGroupDDLClick) { fnGroupDDLClick(); }
        });
        $('#btnImgsDDL').html(`<img src="${groupImgsBaseURL}${g.imgName}" data-img_name="${g.imgName}"> ${g.text} <span class="caret"></span>`)
        $('#btnImgsDDL img').off('error').on('error', (e) => {
            e.target.src = `${testFolderImgsBaseURL}${e.target.dataset.img_name}`;
        });
        $('#divGroupDDL').removeClass('hidden');
    }
}

export {
    getGroupsToolBarDataAsync,
    getGroupsToolBarMenuItem,
    initGroupCtrlsAsync,
    initGroupsDDL,
    initGroupsToolBar,
    setGroupsDDLContent
};